import React from "react";
import { GooglePreviewCard } from "../GooglePreviewCard";

export default function PreviewStep() {
  return (
    <div className="space-y-5">
      <div>
        <div className="inline-flex items-center gap-1.5 text-[11px] font-medium text-emerald-700 bg-emerald-50 border border-emerald-100 px-2.5 py-1 rounded-full mb-3">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 gigma-live-dot" />
          Live preview
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-slate-900">
          How you’ll appear on Google Search
        </h2>
        <p className="text-slate-500 mt-2">
          This is a simulation of your Google listing card. Go back to edit anything you’d like to change.
        </p>
      </div>

      <div className="lg:hidden">
        <GooglePreviewCard />
      </div>
      <div className="hidden lg:block text-sm text-slate-500 bg-slate-50 border border-slate-200 rounded-2xl p-4">
        Your preview is shown live on the right. Scroll the page if you don’t see it.
      </div>
    </div>
  );
}
